<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Estatus</label>
                </div>
                <div class="col-auto">
                    <select @change="Lista()" v-model="Filtro.Estatus" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option value="A">Activos</option>
                        <option value="B">Inactivos</option>
                    </select>
                </div>
            </template>

            


			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Clave</th>
                <th :class="StyleTh">Rfc</th>
                <th :class="StyleTh">Email</th>
                <th :class="StyleTh">Paqueteía</th>
                
                <th :class="StyleTh">Estatus</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
					<td><h6 :class="StylePr">{{lista.Clave}}</h6></td>
					<td><h6 :class="StylePr">{{lista.Rfc}}</h6></td>
               
                    <td><p :class="StyleTd">{{$limitCharacters(lista.Email,35)}}</p></td>
                    <td><p v-if="lista.paqueteria != undefined && lista.paqueteria != null" :class="StyleTd">{{$limitCharacters(lista.paqueteria.Nombre,35)}}</p></td>
                  
                    <td>
                        <span class="badge text-bg-success" v-if="lista.Estatus == 'A'">Activo</span>
                        <span class="badge text-bg-warning" v-if="lista.Estatus == 'B'">Inactivo</span>
                        
                    </td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdCliente" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">

                                <CMoreButtonsL>
							        <template slot="bodyBtnsL">

                                        <li>
                                            <a class="dropdown-item" @click="verUsuarios(lista)">
                                                <i class="far fa-users"></i> Usuarios 
                                                <template v-if="lista.users_count != undefined && lista.users_count != null" >({{ lista.users_count }})</template>
                                            </a>
                                        </li>
                                        <li v-if="segurity.AddAddress">
                                            <a class="dropdown-item" @click="verDirecciones(lista)">
                                                <i class="fas fa-map-marked-alt"></i> Direcciones
                                            </a>
                                        </li>
                                        <li v-if="segurity.Mails">
                                            <a class="dropdown-item" @click="verCorreos(lista)">
                                                <i class="far fa-envelope"></i> Correos
                                            </a>
                                        </li>
                                        <li v-if="segurity.Notification" @click="verNotificaciones(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-bell"></i> Notificaciones
                                            </a>
                                        </li>

                                    </template>
                                </CMoreButtonsL>


                        
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="20"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>

        <!-- DIRECCIONES -->
        <CModal :pConfigModal="ConfigModalDirecciones" :poBtnSave="oBtnSaveDirecciones">
			<template slot="Form">
				<FormDirecciones :poBtnSave="oBtnSaveDirecciones"></FormDirecciones>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/modulos/clientes/Form.vue';
import FormDirecciones from '@/views/modulos/clientes/direcciones/Form.vue';
import Configs from '@/helpers/VarConfig.js';

const EmitEjecuta   = 'seccionCliente';
const EmitEjecuta2  = 'seccionClienteDirecciones';

export default {
    name: 'ListaCliente',
    props: ['sFiltros','pOrigen'],
    components: {
        Form,
        FormDirecciones
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado de Clientes',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                ShowTitleFirst:false,
                TitleFirst: '',
                BtnNewShow:    false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                Estatus:'A'
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'lg'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,

            ConfigModalDirecciones:{
                ModalTitle: "Direcciones Origen/Destino",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg'
            },

            oBtnSaveDirecciones: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("clientes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    Estatus: this.Filtro.Estatus,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('clientes/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },

        verUsuarios(lista){
            this.$router.push({name:'usuariosclientes', 
                params:{
                    sFiltros:'NO',
                    pOrigen:'Clientes',
                    pObjEnviado: lista
                }
            });
        },
        verDirecciones(item){
             this.bus.$emit('NewModal_'+EmitEjecuta2,item);
        },
        verCorreos(item){
            this.$router.push({name:'correoclientes',params:{pObjEnviado:item}});
        },
        verNotificaciones(item){
            this.$router.push({name:'notificacioncliente',params:{pObjEnviado:item}});
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
